import Length from "../../../../source/js/shared/models/Geometry/Length";
import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class HalfCircle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'half-circle', dimensions );
	}

	getDiameter(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getLength(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.diameter.divide( 2 );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.diameter.divide( 2 );
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'diameter' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ this.getDiameter().in_mm(), 0 ], this.renderDimensionLabel( 'diameter' ), [0, -40], ratio, this.getDimensionLineType('measurements-half-circle-diameter', focusedElement, forceRender) ), // Horizontal line
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height', this.getHeight().in_cm() ), [-40, 0], ratio), // Vertical line
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return { diameter: 50 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			diameter: width.divide(2).in_cm(),
		};
	}
}
